import {Obj, Opt, OptNum, OptStr, Str} from '@repo/shared/api/core/api_schema';
import type {SchemaToType} from '@repo/shared/api/core/api_schema';

const TrailerSchema = Obj({youtubeId: Str(), name: Str(), language: Str()});
export type TvTrailer = SchemaToType<typeof TrailerSchema>;
export const TV_TRAILER_API = {
  '/catalogue/trailer': {
    POST: {req: Obj({imdbId: OptStr(), tmdbId: OptNum()}), res: Obj({trailer: Opt(TrailerSchema)})},
  },
};
